import { ArrowForwardIos } from '@mui/icons-material';
import React from 'react'
import pagesdata from "../data/pagesdata"
import styled from 'styled-components';
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import addpath from '../data/addpath'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import flatten from '../data/flattenarray';
import { blue } from '@mui/material/colors';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
`
const BreadCrumbWrapper = styled.div`
    display: flex;
    align-items: center; 
    background-color: #b785ea;
    padding: 1px;
    border-radius: 5px;
`
const BackButtonWrapper = styled.div`
    align-items: center;
    display: flex;
    background-color: #57ccf4;
    font-size: 1.2rem;
    padding: 1px;
    border-radius: 5px;
`
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
const Span = styled.span`
    color: blue;
`

const Navdiv = styled.div`
    margin-right: 5px;
`

const StyledLink = styled(Link)`
    text-decoration: none;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-size: 1.2rem;
    color: blue;
    margin: 3px;
`

const findParentPath = (data, childPath) => {
    let parentPath = null;
    const findPath = (items, path) => {
        for (const item of items) {
            if (item.childrens) {
                for (const child of item.childrens) {
                    if (child.path === path) {
                        parentPath = item.path;
                        return true;
                    }
                }
                if (findPath(item.childrens, path)) {
                    return true;
                }
            }
        }
        return false;
    };

    findPath(data, childPath);
    return parentPath;
};
const clonedData = structuredClone(pagesdata);
const data = addpath(clonedData);

const Navigator = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const id = location.pathname;
    const reqpath = id.split("/");
    reqpath[0] = "home";
    const pathValue = reqpath.length > 1 ? reqpath[reqpath.length - 1] : "home";

    const navarray = (data, list = [], j) => {
        if (j === undefined) { j = 0 };
        data.forEach((i, k) => {
            if (reqpath[j] === i.path.split("/")[(i.path.split("/").length) - 1]) {
                j++;
                if (i.childrens) {
                    let { childrens, ...item } = i;
                    list.push(item)
                } else { list.push(i) }
            }
        })
        for (const obj in data) {
            if (j === ((reqpath.length))) {
                break;
            }
            if (data[obj].childrens) {
                navarray(data[obj].childrens, list, j)
            }
        }
        return list;
    }

    const onClickBackArrow = () => {
        findParentPath(clonedData, pathValue) ?
            navigate(`/${flatten(addpath(clonedData)).find(y => y.title === flatten(clonedData).find(x => x.path === findParentPath(clonedData, pathValue)).title).path}`) :
            navigate("/home")
    }

    const finalarray = navarray(data);

    return (
        <Container>
            <BreadCrumbWrapper>
                {finalarray.map((i, k) => <React.Fragment key={k}> {i.title !== "Home" ? <ArrowForwardIos
                    sx={{ fontSize: 12, color: blue[900] }} /> : null}<Navdiv><StyledLink to={i.path}>{i.title}</StyledLink></Navdiv></React.Fragment>)}
            </BreadCrumbWrapper>
            <BackButtonWrapper>
                {pathValue !== "home" && (findParentPath(clonedData, pathValue) ? <BackArrowContainer onClick={onClickBackArrow} ><KeyboardBackspaceIcon sx={{ color: "blue" }} /><Span>{`Back to ${flatten(clonedData).find(x => x.path === findParentPath(clonedData, pathValue)).title}`}</Span></BackArrowContainer> :
                    <BackArrowContainer onClick={onClickBackArrow}><KeyboardBackspaceIcon sx={{ color: "blue" }} /><Span>{`Back to Home`}</Span></BackArrowContainer>)
                }
            </BackButtonWrapper>
        </Container>
    )
}

export default Navigator;